export function buildFormLink(page, fields = {}) {
    const params = new URLSearchParams()

    for (const [key, raw] of Object.entries(fields)) {
        if (raw == null) continue
        const value = String(raw).replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim()
        if (value !== '') params.set(key, value)
    }

    const query = params.toString()
    return query ? `/${page}?${query}` : `/${page}`
}
